import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';


import * as globalConst from './../../../../constants';

@Injectable()
export class CommercialStructureInsertService {

	private apiUrl = globalConst.baseAPI;  // URL para web api

	/**
	* Método construtor
	* @param http: Http
	*/
	constructor(private http: Http) { }

	listManagers(token) {
		

		
		
		
		
		
		

		return this.http
			.get(this.apiUrl + "commercialstructure/v1/getcommercialstructurebypapel/G", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	insertCommercialStructure(token, commercialData: any) {
		

		
		
		
		
		
		

		return this.http
			.post(this.apiUrl + "commercialstructure/v1/insertcommercialstructuredirector", commercialData, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

}


// WEBPACK FOOTER //
// ./src/app/commercial-structure/service/commercial-structure-insert/commercial-structure-insert.service.ts